// TODO: ces énumérations apportent-elles vraiment quelque chose ? Ne ferait-on pas mieux
// de stocker des minutes, des kw... à voir car elle représente le choix de l'utilisateur
// dans une liste déroulante (la clé de l'option d'un select)...

export enum LoadFileTypeRef {
  power = 'power',
  energy = 'energy'
}

export enum LoadFileDurationRef {
  year_1 = 'year_1',
  week_1 = 'week_1',
  week_2 = 'week_2'
}

export enum LoadFileUnitRef {
  w = 'w',
  kw = 'kw',
  wh = 'wh',
  kwh = 'kwh'
}

export enum LoadFileStepRef {
  minute_1 = 'minute_1',
  minute_5 = 'minute_5',
  minute_10 = 'minute_10',
  minute_15 = 'minute_15',
  minute_30 = 'minute_30',
  hour_1 = 'hour_1'
}

export class LoadFileReferenceUtils {

  public static getNumberOfHoursPerDuration(duration: LoadFileDurationRef): number {
    switch (duration) {
      case LoadFileDurationRef.week_1: return 7 * 24;
      case LoadFileDurationRef.week_2: return 2 * 7 * 24;
      case LoadFileDurationRef.year_1: return 365 * 24;
      default: throw new Error('How did you get there ?!');
    }
  }

  public static getUnitToKiloMultiplier(unit: LoadFileUnitRef): number {
    switch (unit) {
      case LoadFileUnitRef.w: return 1000;
      case LoadFileUnitRef.kw: return 1;
      case LoadFileUnitRef.wh: return 1000;
      case LoadFileUnitRef.kwh: return 1;
      default: throw new Error('How did you get there ?!');
    }
  }

  public static getNumberOfValuesPerHour(step: LoadFileStepRef): number {
    switch (step) {
      case LoadFileStepRef.minute_1: return 60;
      case LoadFileStepRef.minute_5: return 12;
      case LoadFileStepRef.minute_10: return 6;
      case LoadFileStepRef.minute_15: return 4;
      case LoadFileStepRef.minute_30: return 2;
      case LoadFileStepRef.hour_1: return 1;
      default: throw new Error('How did you get there ?!');
    }
  }

}
